module.exports = __webpack_public_path__ + "media/images/Calendar-d21f41bd.svg";